// src/components/SocialShare.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTwitter,
  faFacebookF,
  faLinkedinIn,
  faRedditAlien,
} from '@fortawesome/free-brands-svg-icons';


const SocialShare = ({ url, title, description }) => {
  const shareUrl = encodeURIComponent(url || window.location.href);
  const shareTitle = encodeURIComponent(title || document.title);

  const platforms = {
    twitter: `https://twitter.com/intent/tweet?text=${shareTitle}&url=${shareUrl}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`,
    reddit: `https://reddit.com/submit?url=${shareUrl}&title=${shareTitle}`,
    whatsapp: `https://api.whatsapp.com/send?text=${shareTitle} ${shareUrl}`
  };

  const handleShare = (platform) => {
    window.open(platforms[platform], '_blank', 'width=600,height=400');
  };

  return (
    <div className="flex flex-col gap-3 py-6 border-y border-outline-variant/30">
      <span className="label-caps text-xs text-outline tracking-tighter">Broadcast_Intel</span>
      <div className="flex gap-2">
        <button
          onClick={() => handleShare('twitter')}
          className="w-10 h-10 flex items-center justify-center glass-card rounded-lg text-primary hover:bg-primary/10 transition-colors"
          aria-label="Share on Twitter"
        >
          <FontAwesomeIcon icon={faTwitter} className="text-lg" />
        </button>
        <button
          onClick={() => handleShare('facebook')}
          className="w-10 h-10 flex items-center justify-center glass-card rounded-lg text-primary hover:bg-primary/10 transition-colors"
          aria-label="Share on Facebook"
        >
          <FontAwesomeIcon icon={faFacebookF} className="text-lg" />
        </button>
        <button
          onClick={() => handleShare('linkedin')}
          className="w-10 h-10 flex items-center justify-center glass-card rounded-lg text-primary hover:bg-primary/10 transition-colors"
          aria-label="Share on LinkedIn"
        >
          <FontAwesomeIcon icon={faLinkedinIn} className="text-lg" />
        </button>
        <button
          onClick={() => handleShare('reddit')}
          className="w-10 h-10 flex items-center justify-center glass-card rounded-lg text-primary hover:bg-primary/10 transition-colors"
          aria-label="Share on Reddit"
        >
          <FontAwesomeIcon icon={faRedditAlien} className="text-lg" />
        </button>
      </div>
    </div>
  );
};

export default SocialShare;